export default "__VITE_ASSET__CDCIUBhM__"